export const buttonMap = { target: 'onClick' };
